import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface IUseScrollTopView {
  top?: number;
  smoothScroll?: boolean;
}

export const useScrollTopView = ({ top, smoothScroll }: IUseScrollTopView) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: top || 0,
      behavior: smoothScroll ? 'smooth' : 'auto',
    });
  }, [top, smoothScroll, pathname]);

  return null;
};
